var exports = {
  "JC": "Accordion.module__accordion___U0Z0dl",
  "U1": "Accordion.module__headerRow___U0Z0dl",
  "L9": "Accordion.module__headerClickTarget___U0Z0dl",
  "N4": "Accordion.module__titleButton___U0Z0dl",
  "Z2": "Accordion.module__descriptionButton___U0Z0dl",
  "me": "Accordion.module__caretButton___U0Z0dl",
  "VW": "Accordion.module__headerContent___U0Z0dl",
  "$": "Accordion.module__titleRow___U0Z0dl",
  "QE": "Accordion.module__headerAction___U0Z0dl",
  "ID": "Accordion.module__compactTitle___U0Z0dl",
  "SY": "Accordion.module__compactDescription___U0Z0dl",
  "OW": "Accordion.module__caret___U0Z0dl",
  "bd": "Accordion.module__caretExpanded___U0Z0dl",
  "FG": "Accordion.module__contentWrapper___U0Z0dl",
  "Qs": "Accordion.module__content___U0Z0dl",
};

module.exports = exports;
